import { createSelector } from 'reselect'
import _ from 'lodash'

const getForms = state => state.Forms.forms
const getStages = state => state.Forms.stages
const getFunnels = state => state.Forms.funnels
const getFunnelsStages = state => state.Forms.funnelsStages
const getQuestionsGroups = state => state.Forms.questionsGroups
const getQuestions = state => state.Forms.questions
const getFormMergedWithAll = form => form

export const FormsMergeWithState = createSelector(
  [
    getForms,
    getStages,
    getFunnels,
    getFunnelsStages,
    getQuestionsGroups,
    getQuestions,
  ],
  (...allState) => {
    const [
      forms,
      stages,
      funnels,
      funnelsStages,
      questionsGroups,
      questions,
    ] = allState

    const questionsGrouped = _.groupBy(questions, 'question_group_id')
    const questionsGroupsMerge = _.map(questionsGroups, questionGroup => ({
      ...questionGroup,
      questions: questionsGrouped[questionGroup._id],
    }))
    const questionsGroupsMergeGrouped = _.groupBy(questionsGroupsMerge, 'stage_id')
    const stagesMerge = _.map(stages, stage => ({
      ...stage,
      questionsGroups: _.orderBy(questionsGroupsMergeGrouped[stage._id] || [], 'order'),
    }))
    const stagesKeyed = _.keyBy(stagesMerge, '_id')
    const funnelsKeyed = _.keyBy(funnels, '_id')
    const funnelMergeStages = _.reduce(funnelsStages, (acum, funnelStage) => {
      const aux = acum[funnelStage.funnel_id]

      if (!aux) {
        return {
          ...acum,
          [funnelStage.funnel_id]: {
            ...funnelsKeyed[funnelStage.funnel_id],
            stages: [{
              ...stagesKeyed[funnelStage.stage_id],
              order: funnelStage.order,
            }],
          }
        }
      }

      return {
        ...acum,
        [funnelStage.funnel_id]: {
          ...aux,
          ...funnelsKeyed[funnelStage.funnel_id],
          stages: _.orderBy(aux.stages.concat({
            ...stagesKeyed[funnelStage.stage_id],
            order: funnelStage.order,
          }), 'order'),
        }
      }
    }, {})
    const formsMergeWithAll = forms.map(form => ({
      ...form,
      funnel: funnelMergeStages[form.funnel_id],
    }))

    return {
      forms: formsMergeWithAll,
      formsKeyed: _.keyBy(formsMergeWithAll, '_id'),
    }
  }
)

export const QuestionsGroupsByReactiveForms = createSelector(
  getFormMergedWithAll,
  form => {
    if (!form) return []

    const questionsGroups = _.reduce(
      form.funnel.stages,
      (acum, stage) => acum.concat(stage.questionsGroups),
      [],
    )

    return questionsGroups
  },
)
